import React from "react";
import { Link } from "react-router-dom";

export function Footer({ compact = false }) {
  return (
    <footer
      data-testid="site-footer"
      className={`relative border-t border-border bg-card/30 ${compact ? "py-3" : "py-5"}`}
    >
      <div className="mx-auto max-w-6xl flex flex-col sm:flex-row items-center justify-between gap-2 px-5 text-[11px] text-muted-foreground">
        <p className="tabular">
          © {new Date().getFullYear()} VideoLens — YouTube Video Intelligence
        </p>
        <nav className="flex items-center gap-4">
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-foreground transition-colors"
          >
            Terms &amp; Conditions
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:text-foreground transition-colors"
          >
            Privacy Policy
          </Link>
          <a
            href="mailto:[Insert official support email]"
            className="hover:text-foreground transition-colors"
          >
            Contact
          </a>
        </nav>
      </div>
    </footer>
  );
}
